import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import SubHeader from "./components/SubHeader";
import NotificationList from "./components/NotificationList";

export default function Notifications() {
  return (
    <div>
      <SubHeader />
      <div className="mx-auto max-w-6xl w-full px-4 pb-3 bg-white shadow-sm rounded-lg">
        <div className="border-b border-gray-200 px-4 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold">Your Notifications</h1>
            {/* <div className="relative">
              <input
                type="text"
                placeholder="Search"
                className="pl-8 pr-4 py-2 border border-gray-300 rounded-md w-80 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
              />
              <MagnifyingGlassIcon className="w-4 h-4 text-gray-400 absolute left-2 top-1/2 transform -translate-y-1/2" />
            </div> */}
          </div>
        </div>
        <div className="px-4 py-4 font-semibold text-gray-700">Activity</div>
        <NotificationList />
      </div>
    </div>
  );
}
